import { Stack } from "react-bootstrap";
import ViewToolsContainer from "../../../../../boundarySelection/ViewTools/ViewToolsContainer";
import type { InrixVolumesViewOrderItemSummary } from "../../../../../../types/ViewOrderItem/InrixVolumes/InrixVolumesViewOrderItemSummary";
import OrderItemInrixVolumeDayDropdown from "./OrderItemInrixVolumeDayDropdown";
import OrderItemInrixVolumeTimePeriodControl from "./OrderItemInrixVolumeTimePeriodControl";
import OrderItemInrixVolumeSegmentDropdown from "./OrderItemInrixVolumeSegmentDropdown";
import { OrderItemInrixVolumeLineThicknessKey } from "../keys";

interface OrderItemInrixVolumesViewToolsProps {
  summary: InrixVolumesViewOrderItemSummary | null;
}

const OrderItemInrixVolumesViewTools = ({
  summary,
}: OrderItemInrixVolumesViewToolsProps) => {
  return (
    <ViewToolsContainer style={{ width: "620px" }}>
      <Stack gap={2}>
        <div className="d-flex gap-2">
          <div style={{ width: "285px" }}>
            <OrderItemInrixVolumeTimePeriodControl />
          </div>
          <OrderItemInrixVolumeLineThicknessKey summary={summary} />
        </div>
        <OrderItemInrixVolumeDayDropdown />
        <OrderItemInrixVolumeSegmentDropdown />
      </Stack>
    </ViewToolsContainer>
  );
};

export default OrderItemInrixVolumesViewTools;
